const topics = [
  {
    title: '暑期档热门电影大盘点',
    desc: '2024暑期档不容错过的精彩大片，从动作巨制到温情动画，总有一部适合你。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collection%20display%2C%20vibrant%20warm%20colors%2C%20cinematic%20epic%20atmosphere%2C%20professional%20film%20curation%2C%20dramatic%20lighting%2C%20entertainment%20photography%20with%20excitement&width=1200&height=680&seq=carousel-1&orientation=landscape',
    alt: '暑期档热门电影大盘点',
  },
  {
    title: '豆瓣高分华语电影精选',
    desc: '豆瓣8分以上的华语佳作，从文艺片到商业大片，品质保证值得一看。',
    img: 'https://readdy.ai/api/search-image?query=Award%20winning%20Chinese%20language%20films%20collection%20display%2C%20elegant%20artistic%20composition%2C%20warm%20ambient%20cinematic%20lighting%2C%20sophisticated%20film%20aesthetic%2C%20professional%20photography&width=1200&height=680&seq=carousel-2&orientation=landscape',
    alt: '豆瓣高分华语电影精选',
  },
  {
    title: '年度必看剧集推荐',
    desc: '2024年不容错过的口碑剧集，涵盖悬疑、都市、古装等多种类型。',
    img: 'https://readdy.ai/api/search-image?query=Must%20watch%20TV%20series%20collection%202024%2C%20modern%20streaming%20entertainment%20concept%2C%20warm%20cozy%20viewing%20atmosphere%2C%20professional%20lifestyle%20photography%2C%20clean%20cinematic%20composition&width=1200&height=680&seq=carousel-3&orientation=landscape',
    alt: '年度必看剧集推荐',
  },
  {
    title: '悬疑烧脑电影合集',
    desc: '高智商悬疑片精选，反转不断、烧脑刺激，每一部都让人欲罢不能。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20collection%2C%20dark%20dramatic%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20cinematic%20suspense%20aesthetic%2C%20professional%20photography%20with%20tension&width=1200&height=680&seq=carousel-4&orientation=landscape',
    alt: '悬疑烧脑电影合集',
  },
  {
    title: '治愈系温暖电影推荐',
    desc: '温暖人心的治愈系电影，在忙碌的生活中给自己一段温柔时光。',
    img: 'https://readdy.ai/api/search-image?query=Heartwarming%20healing%20movies%20collection%2C%20soft%20warm%20golden%20lighting%2C%20cozy%20comfortable%20atmosphere%2C%20gentle%20emotional%20aesthetic%2C%20professional%20lifestyle%20photography%20with%20peaceful%20mood&width=1200&height=680&seq=carousel-5&orientation=landscape',
    alt: '治愈系温暖电影推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精心策划的影视专题，帮你发现更多好内容
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {topics.map((topic, i) => (
            <article
              key={i}
              className={`group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[21/9]' : 'aspect-[16/10]'}`}>
                <img
                  src={topic.img}
                  alt={topic.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-white mb-1">
                    {topic.title}
                  </h3>
                  <p className="text-xs text-white/75 line-clamp-2">
                    {topic.desc}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}